<script lang="ts">
  import { quadMeta, isQuadrant } from '@ui/quadrant';

  // The member's value-vs-volume category (see the Contributors insight). Null
  // when they have no activity yet, in which case nothing renders.
  let { quadrant, class: cls = '' }: { quadrant: string | null | undefined; class?: string } = $props();
  const meta = $derived(quadMeta(quadrant));
</script>

{#if isQuadrant(quadrant)}
  <span
    class="inline-flex items-center gap-1 rounded px-1.5 py-0.5 font-mono text-[0.65rem] {cls}"
    style:background="color-mix(in oklab, {meta.color} 15%, transparent)"
    style:color={meta.color}
    title="Contributor category · {meta.blurb}"
  >
    <span class="inline-block h-1.5 w-1.5 rounded-full" style:background={meta.color}></span>
    {meta.label}
  </span>
{/if}
